import { useLocation } from "react-router-dom";
import { useBrand, pageBannerKey } from "../lib/branding";
import { PageHero } from "./dashboard/Widgets";
import { LockStar } from "./LockStar";
import { BannerPlus } from "./BannerPicker";


export function PageHeader({ overline, title, desc, children }) {
  const brand = useBrand();
  const { pathname } = useLocation();
  const key = pageBannerKey(pathname);
  const banner = brand?.[key];
  const star = <div className="absolute right-3 top-3 z-20 flex items-center gap-1.5"><BannerPlus slot={key} /><LockStar id={`page:${pathname}`} /></div>;
  if (banner) return <div className="relative">{star}<PageHero url={banner} overlay={brand[`${key}_overlay`] ?? 50} overline={overline} title={title} desc={desc}>{children}</PageHero></div>;
  return (
    <div className="relative flex flex-wrap items-end justify-between gap-4 mb-8 fade-up">
      {star}
      <div>
        {overline && <div className="overline mb-2">{overline}</div>}
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight" data-testid="page-title">{title}</h1>
        {desc && <p className="text-sm text-muted-foreground mt-2 max-w-2xl">{desc}</p>}
      </div>
      <div className="flex flex-wrap gap-2">{children}</div>
    </div>
  );
}

export function Stat({ label, value, sub, icon: Icon, testid, accent }) {
  return (
    <div className="rounded-md border bg-card p-5 fade-up" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="overline">{label}</span>
        {Icon && <Icon className={`h-4 w-4 ${accent ? "text-accent" : "text-primary"}`} />}
      </div>
      <div className="mt-3 text-2xl font-display font-bold">{value}</div>
      {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
    </div>
  );
}

const TONES = {
  green: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  amber: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  red: "bg-red-500/10 text-red-400 border-red-500/30",
  blue: "bg-sky-500/10 text-sky-400 border-sky-500/30",
  teal: "bg-[#C2A462]/10 text-[#D9C08A] border-[#C2A462]/35",
  slate: "bg-slate-500/10 text-slate-300 border-slate-500/30",
};

export function Pill({ tone = "slate", children, testid }) {
  return <span data-testid={testid} className={`inline-flex items-center rounded-sm border px-2 py-0.5 text-[11px] font-mono uppercase tracking-wider ${TONES[tone]}`}>{children}</span>;
}

export const statusTone = (s) =>
  ({ active: "green", no_charge: "teal", connected: "green", paid: "green", won: "green", closed: "slate", completed: "green", open: "amber",
     unpaid: "amber", investigating: "blue", suspended: "red", cancelled: "red", lost: "red", critical: "red", high: "red",
     medium: "amber", low: "blue", disconnected: "slate", draft: "slate", published: "teal", scheduled: "blue" }[String(s).toLowerCase()] || "slate");
